var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryChick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.097,
    height: 66.406,
    viewBox: "0 0 48.097 66.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(17.979 8.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M29.608,7.956a30.032,30.032,0,0,0-1.1-3.88L22.145,14.421,20.991,16.3l-1.033-1.961-2.6-4.917L13.3,14.554l-.7.883-.93-.586-6.2-3.922L-.835,16.906-2.08,18.084-2.831,16.5-9.882,1.649a29.25,29.25,0,0,0-1.772,4.973,31.632,31.632,0,0,0-1,7.943A29.325,29.325,0,0,0-6.314,33.2c3.88,4.714,9.23,7.628,15.133,7.628S20.075,37.91,23.952,33.2a29.342,29.342,0,0,0,6.339-18.631,31.723,31.723,0,0,0-.683-6.61M29.9.592a32.543,32.543,0,0,1,2.217,6.76,34.752,34.752,0,0,1,.754,7.213,32.237,32.237,0,0,1-6.992,20.459c-4.357,5.291-10.387,8.568-17.056,8.568s-12.7-3.277-17.056-8.568a32.237,32.237,0,0,1-6.992-20.459,34.644,34.644,0,0,1,1.1-8.682,31.737,31.737,0,0,1,3.209-7.89l1.2-2.084L-8.684-1.91l7.393,15.572L4.468,8.2l.7-.66.8.5,6.074,3.842L16.592,6.13l1.192-1.507.9,1.716,2.47,4.681L27.671.436l1.237-2.008Z",
    transform: "translate(-2.75 14.298)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M20.186,17.512a14.971,14.971,0,0,0-3.077-5.144,6.527,6.527,0,0,0-4.057-2.008l-1.322-.132.159-1.407C12.29,5.3,11.15,2,10.008-1.313v-.006l-.183-.53C8.689-5.156,5.833-6.4,2.768-6.23A12.868,12.868,0,0,0-3.594-4.019,9.594,9.594,0,0,0-7.5.812C-8.267,3.212-7.622,6.077-4.557,9l.816.777-.58.989L-5.4,12.6l-.244.312c-2.623,2.45-2.058,7.137-1.175,14.5.162,1.357.18,1.466.256,2.1l-2.559.336-.244-2.09c-.977-8.141-1.608-13.361,1.893-16.791l.415-.707C-10.348,6.707-10.946,3.091-9.936-.077A12.3,12.3,0,0,1-4.96-6.351,15.364,15.364,0,0,1,2.65-8.989C6.769-9.21,10.638-7.452,12.243-2.8l.177.524h0C13.541.965,14.654,4.192,14.539,7.831a9.1,9.1,0,0,1,4.328,2.526,17.664,17.664,0,0,1,3.695,6.086Z",
    transform: "translate(3.406 0.492)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M4.318,1.734A1.422,1.422,0,0,0,4.937-.1a1.248,1.248,0,0,0-1.7-.665L-1.482,1.616A1.422,1.422,0,0,0-2.1,3.448a1.251,1.251,0,0,0,1.708.665Z",
    transform: "translate(-9.448 2.322)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M.881.063A1.65,1.65,0,0,1,3.042,1.085,1.818,1.818,0,0,1,1.764,3.216,1.648,1.648,0,0,1-.4,2.194,1.812,1.812,0,0,1,.881.063",
    transform: "translate(0.453 0.032)",
    fill: "#edaa30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryChick);
export default __webpack_public_path__ + "static/media/primary-chick.568c6f6113f689dc43ba0481e33f2097.svg";
export { ForwardRef as ReactComponent };